import React from 'react';
import PropTypes from 'prop-types';
import InfoDialog from 'components/custom/InfoDialog';
import IntlMessages from 'utils/IntlMessages';

/**
 * InfoDialogWithAlert - A reusable component that displays information with an alert section
 * @param {string} title - The title key for the modal header (IntlMessages key)
 * @param {string} headerText - The header text key inside the modal (IntlMessages key)
 * @param {string} description - The description text key (IntlMessages key)
 * @param {string} alertText - The alert message text key (IntlMessages key)
 * @param {string} alertIcon - Optional icon class for the alert (default: zmdi-info-outline)
 * @param {string} className - Optional className for the InfoDialog button
 */
const InfoDialogWithAlert = ( {
  title,
  headerText,
  description,
  alertText,
  alertIcon,
  className,
} ) => (
  <InfoDialog title={title} className={className}>
    <div className="p-4">
      <div className="mb-3">
        <p className="mb-2">
          <strong>
            <IntlMessages id={headerText} />
            :
          </strong>
        </p>
        <p className="text-muted mb-0">
          <IntlMessages id={description} />
        </p>
      </div>

      <div className="alert alert-info mb-0" style={{ fontSize: '0.9rem' }}>
        <i className={`zmdi ${alertIcon} mr-2`} />
        <IntlMessages id={alertText} />
      </div>
    </div>
  </InfoDialog>
);

InfoDialogWithAlert.propTypes = {
  title: PropTypes.string.isRequired,
  headerText: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  alertText: PropTypes.string.isRequired,
  alertIcon: PropTypes.string,
  className: PropTypes.string,
};

InfoDialogWithAlert.defaultProps = {
  alertIcon: 'zmdi-info-outline',
  className: '',
};

export default InfoDialogWithAlert;

